const baseStyle = {
  // textTransform: "uppercase",
};

export default {
  baseStyle,
};
